import { Input } from "components/Form/components/Input/Input";
import { FormComponentProps } from "../FormComponentProps";
import { Text } from "./Text";

export type TextFormComponentProps = {};

export const TextFormComponent = ({ input, meta, fieldProps, fieldAttr }: FormComponentProps) => {
    return (
        <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
            <Text name={input.name} inputProps={input} attributes={fieldAttr}></Text>
        </Input>
    );
};
